<template>
    <CardPrimary :title="modoEdicion ? 'Editar Pedido' : 'Nuevo Pedido'">
        <template v-slot:container>

            <!-- Panel de acciones tras confirmar -->
            <div v-if="pdfBase64" class="col-12 mb-3">
                <CardSecondary title="Pedido guardado" classCard="bg-light" classCuerpo="bg-white">
                    <template v-slot:cuerpo>
                        <div class="col-12 py-3 d-flex flex-wrap gap-2 justify-content-center">
                            <button class="btn btn-success px-4" @click="descargarPdf">
                                <i class="fa fa-download me-2"></i>Descargar PDF
                            </button>
                            <button class="btn btn-outline-success px-4" v-if="puedeCompartir" @click="compartirWhatsapp">
                                <i class="fa fa-share-alt me-2"></i>Compartir
                            </button>
                            <a :href="whatsappUrl" target="_blank" class="btn btn-outline-secondary px-4" v-if="!puedeCompartir">
                                <i class="fa fa-share me-2"></i>Enviar por WhatsApp
                            </a>
                            <button class="btn btn-outline-primary px-4" @click="router.push({ name: 'ListarPedidos' })">
                                Ir a pedidos
                            </button>
                        </div>
                    </template>
                </CardSecondary>
            </div>

            <CardSecondary title="Datos del cliente" classCard="bg-light" classCuerpo="bg-white">
                <template v-slot:cuerpo>
                    <div class="col-12 row">
                        <div class="form-floating form-group col-12">
                            <SelectSearch ref="selectSearch" url="clientes" palceholder="Ingrese el apellido"
                                campo="full_name" :subCampo="subCampoClienteSearch" @retorno='(cliente.id = $event.id),
                                    (cliente.apellido = $event.apellido),
                                    (cliente.nombre = $event.nombre),
                                    (cliente.cuit = $event.cuit),
                                    (cliente.email = $event.email),
                                    (cliente.full_name = $event.full_name)'>
                                <label for="floatingInput">Seleccione el cliente</label>
                                <div class="text-danger" v-if="data.enviado && v$.cliente.full_name.$error">Debe buscar
                                    un cliente</div>
                            </SelectSearch>
                        </div>
                        <div class="form-floating form-group col-sm-6 col-12">
                            <input type="text" v-model="cliente.cuit" placeholder="cuit" class="form-control" />
                            <label for="floatingInput">CUIT</label>
                            <div class="text-danger" v-if="data.enviado && v$.cliente.cuit.$error">Debe ingresar un CUIT
                            </div>
                        </div>
                        <div class="form-floating form-group col-sm-6 col-12">
                            <input type="text" v-model="cliente.email" placeholder="Email" class="form-control" />
                            <label for="floatingInput">Email</label>
                            <div class="text-danger" v-if="data.enviado && v$.cliente.email.$error">Debe ingresar un
                                Email</div>
                        </div>
                    </div>
                </template>
            </CardSecondary>
            <CardSecondary title="Productos del pedido" classCard="bg-light" classCuerpo="bg-white">
                <template v-slot:cuerpo>
                    <div class="row px-3">
                        <div class="form-floating form-group col-sm-6 col-12">
                            <select class="form-select" id="floatingSelect" v-model="listaSelected.id">
                                <option v-for="(lista, i) in listas" :key="i" :value="lista.id">{{ lista.nombre }}
                                </option>
                            </select>
                            <label for="floatingSelect">Listas de precio</label>
                        </div>
                        <div class="form-floating form-group col-sm-6 col-12" v-if="listaSelected?.id != null">
                            <SelectSearch ref="selectProducto" :url="'listas/productoslista/' + listaSelected.id"
                                palceholder="Seleccione el producto" campo="nombre_precio"
                                @retorno="(producto.id = $event.id), (producto.descripcion = $event.descripcion), (producto.precio = $event.precio)">
                                <label for="floatingInput">Seleccione el producto</label>
                                <div class="text-danger" v-if="data.productoEnviado && v$.producto.descripcion.$error">
                                    Debe buscar un producto</div>
                            </SelectSearch>
                        </div>
                        <div class="col-12 col-md-6" v-else>
                            <p>Seleccione una lista para buscar productos</p>
                        </div>
                        <div class="col-12 row" v-if="listaSelected?.id != null">
                            <div class="form-floating form-group col-12 col-md-6">
                                <input type="text" v-model="producto.cantidad" placeholder="cantidad"
                                    class="form-control" style="color:black;font-weight: 500;" />
                                <label for="floatingInput">Cantidad</label>
                                <div class="text-danger" v-if="data.productoEnviado && v$.producto.cantidad.$error">Debe
                                    ingresar Cantidad</div>
                            </div>
                            <div class="col-12 col-md-6 text-right mt-4 pb-4">
                                <button class="btn btn-outline-info col-12 col-sm-auto" @click="cargarProducto"><i
                                        class="fa fa-plus pr-2 my-auto"></i>Agregar</button>
                            </div>
                        </div>
                    </div>
                </template>
            </CardSecondary>
            <CardSecondary title="Detalle del pedido" classCard="bg-light" classCuerpo="bg-white">
                <template v-slot:cuerpo>
                    <div class="row col-12 ms-3 pe-4 pb-5">
                        <div class="hovereable card-post--1 col-12 shadow-none row border-bottom mb-3 mt-1"
                            v-for="(listaProducto, index) in listaProductos" :key="index">
                            <div class="col-12 pt-1 mb-1 text-muted">
                                <div class="row">
                                    <div class="col-sm-11 col-10 row">
                                        <span class="col-12 col-sm-12 pb-0 row text-info pr-0 my-3">
                                            <b class="col-sm-11 col-10 col-lg-10">{{ listaProducto.descripcion }}</b>
                                        </span>
                                        <span class="col-12 col-lg-3 col-sm-5">Precio:
                                            <b>{{ formatMoney(listaProducto.precio) }}</b></span>
                                        <span class="col-12 col-lg-3 col-sm-5">Cantidad:
                                            <b>{{ listaProducto.cantidad }}</b></span>
                                        <span class="col-12 col-lg-3 col-sm-5">Total:
                                            <b>{{ formatMoney(listaProducto.subTotal) }}</b></span>
                                    </div>
                                    <span class="col-2 col-sm-1 col-lg-1 text-right align-items-center d-flex justify-content-right">
                                        <button @click="quitar(index, listaProducto)" class="btn text-danger">
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 row">
                                <div class="form-floating form-group col-12 col-md-6">
                                    <input type="number" v-model="descuento" placeholder="Descuento"
                                        class="form-control" step="1" />
                                    <label for="floatingInput" :class="`${descuento > 0 && 'text-danger'}`">Descuento</label>
                                </div>
                                <div class="text-end form-group col-12 col-md-6 row" v-if="descuento > 0">
                                    <span>{{ formatMoney(total) }}</span>
                                    <span style="color: red;">-{{ formatMoney(descuento) }}</span>
                                    <div class="border-top">
                                        <span v-if="saldoAFavor > 0" class="text-warning fw-bold">
                                            Saldo a favor: {{ formatMoney(saldoAFavor) }}
                                        </span>
                                        <span v-else>{{ formatMoney(totalConDescuento) }}</span>
                                    </div>
                                </div>
                                <div class="my-3 col-12" v-if="listaProductos.length > 0">
                                    <div v-if="saldoAFavor > 0" class="bg-warning col-sm-3 col-12 float-right py-2 rounded">
                                        <h5 class="text-dark text-center">Saldo a favor: {{ formatMoney(saldoAFavor) }}</h5>
                                    </div>
                                    <div v-else class="bg-success col-sm-2 col-12 float-right py-2 rounded">
                                        <h5 class="text-white text-center">Total: {{ formatMoney(totalConDescuento) }}</h5>
                                    </div>
                                </div>
                                <div class="col-12 py-3 text-end">
                                    <button class="btn btn-outline-primary col-12 col-sm-auto" @click="confirmarPedido"
                                        :disabled="listaProductos.length == 0">
                                        {{ modoEdicion ? 'Guardar cambios' : 'Confirmar' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </CardSecondary>
        </template>
    </CardPrimary>
</template>
<script>
import CardPrimary from "plantilla-share/src/lib-components/CardPrimary";
import CardSecondary from "plantilla-share/src/lib-components/CardSecondary";
import SelectSearch from "@/components/layouts/SelectSearch";
import { reactive, ref, onMounted, watchEffect, computed } from "vue";
import Lista from '../listas/lista'
import { required } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import Axios from 'axios';
import Alert from '@/components/utils/alert'
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import PedidosService from '@/components/pedidos/pedidos';

export default {
    name: "AgregarPedidos",
    components: {
        CardPrimary,
        CardSecondary,
        SelectSearch
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        const modoEdicion = computed(() => !!route.params.id);
        const pedidoId = route.params.id || null;

        const subCampoClienteSearch = [
            { nombre: 'Cuit:', key: 'cuit', clase: 'text-primary col-12 col-lg-6 d-flex d-sm-inline' },
            { nombre: 'Email:', key: 'email', clase: 'text-primary col-12 col-lg-6 d-flex d-sm-inline' }
        ];
        const v$ = useVuelidate();
        let data = reactive({ enviado: false, productoEnviado: false, error: false });
        let descuento = ref(0);
        const pdfBase64 = ref(null);
        const puedeCompartir = ref(!!navigator.share);

        const cliente = ref({ id: null, nombre: null, full_name: null, apellido: null, email: null, cuit: null });
        let producto = reactive({ id: null, descripcion: null, precio: null, cantidad: 1, subTotal: null });
        const listaProductos = ref([]);
        let total = ref(0);
        let listaSelected = reactive({ id: null });
        let listas = ref([]);
        const selectSearch = ref(null);
        const selectProducto = ref(null);

        const formatMoney = (value) => {
            if (value === null || value === undefined) return '$ 0'
            return '$ ' + Number(value).toLocaleString('es-AR')
        }

        const totalConDescuento = computed(() => {
            const descuentoAplicado = Math.floor(descuento.value);
            return Math.max(0, total.value - descuentoAplicado);
        });

        const saldoAFavor = computed(() => {
            const descuentoAplicado = Math.floor(descuento.value);
            return Math.max(0, descuentoAplicado - total.value);
        });

        const whatsappUrl = computed(() => {
            if (!pdfBase64.value) return '#'
            const texto = encodeURIComponent(`Pedido de ${cliente.value.full_name} - Total: ${formatMoney(totalConDescuento.value)}`)
            return `https://wa.me/?text=${texto}`
        })

        onMounted(async () => {
            listas.value = await Lista.getListas();
            if (modoEdicion.value) {
                await cargarPedidoExistente();
            } else {
                getStorageListaProductos();
            }
        });

        const cargarPedidoExistente = async () => {
            limpiarStorage();
            try {
                const pedido = await PedidosService.getPedido(pedidoId);
                cliente.value = {
                    id: null,
                    full_name: pedido.cliente_nombre,
                    nombre: pedido.cliente_nombre,
                    apellido: pedido.cliente_nombre,
                    cuit: pedido.cliente_cuit,
                    email: pedido.cliente_email,
                };
                descuento.value = pedido.descuento || 0;
                const productos = pedido.pedido_productos.map(pp => ({
                    id: null,
                    descripcion: pp.producto,
                    precio: parseFloat(pp.precio),
                    cantidad: pp.cantidad,
                    subTotal: parseFloat(pp.precio) * pp.cantidad,
                }));
                listaProductos.value = productos;
                total.value = productos.reduce((acc, p) => acc + p.subTotal, 0);
                if (selectSearch.value) selectSearch.value.search = pedido.cliente_nombre;
            } catch {
                Alert.Error({ text: 'No se pudo cargar el pedido' })
                    .then(() => router.push({ name: 'ListarPedidos' }));
            }
        };

        const cargarProducto = () => {
            data.productoEnviado = true;
            data.error = false;
            v$.value.producto.$touch();
            if (v$.value.producto.$invalid) return false;

            producto.subTotal = producto.cantidad * producto.precio;
            if (producto?.id) {
                total.value += producto.subTotal;
                listaProductos.value.push({ ...producto });
                producto.descripcion = null;
                producto.precio = null;
                producto.id = null;
                producto.cantidad = 1;
                if (selectProducto.value) selectProducto.value.search = null;
                data.productoEnviado = false;
            } else {
                return false;
            }
        }

        const quitar = (posicion, prod) => {
            listaProductos.value.splice(posicion, 1);
            total.value = total.value - prod.subTotal;
        }

        const manejarRespuestaPdf = (responseData) => {
            pdfBase64.value = responseData.pdf;
            limpiarStorage();
        };

        const limpiarStorage = () => {
            localStorage.removeItem('listaProductos');
            localStorage.removeItem('cliente');
            localStorage.removeItem('total');
            localStorage.removeItem('descuento');
        };

        const descargarPdf = () => {
            const byteChars = atob(pdfBase64.value);
            const byteArr = new Uint8Array(byteChars.length);
            for (let i = 0; i < byteChars.length; i++) byteArr[i] = byteChars.charCodeAt(i);
            const blob = new Blob([byteArr], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Pedido-${cliente.value.full_name}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
        };

        const compartirWhatsapp = async () => {
            try {
                const byteChars = atob(pdfBase64.value);
                const byteArr = new Uint8Array(byteChars.length);
                for (let i = 0; i < byteChars.length; i++) byteArr[i] = byteChars.charCodeAt(i);
                const blob = new Blob([byteArr], { type: 'application/pdf' });
                const file = new File([blob], `Pedido-${cliente.value.full_name}.pdf`, { type: 'application/pdf' });
                await navigator.share({ files: [file], title: 'Pedido' });
            } catch {
                Alert.Error({ text: 'No se pudo compartir el archivo.' });
            }
        };

        const confirmarPedido = () => {
            data.enviado = true;
            data.error = false;
            v$.value.cliente.$touch();
            if (v$.value.cliente.$invalid || listaProductos.value.length == 0) return false;

            data.enviado = false;
            const payload = {
                productos: listaProductos.value,
                cliente: cliente.value,
                descuento: descuento.value,
                total: total.value,
                user: store.state.user.id
            };

            const request = modoEdicion.value
                ? Axios.put('pedidos/' + pedidoId, payload)
                : Axios.post('pedidos', payload);

            request
                .then((e) => {
                    if (e.data.success) {
                        if (modoEdicion.value) {
                            pdfBase64.value = e.data.pdf;
                            Alert.Option({
                                icon: 'success',
                                titles: '¡Pedido actualizado!',
                                html: '<p>El pedido fue actualizado con éxito.</p><p>¿Deseás descargar el remito?</p>',
                                confirmButtonText: 'Descargar PDF',
                                confirmButtonColor: '#198754',
                                cancelButtonText: 'Cerrar',
                                cancelButtonColor: '#6c757d',
                            }).then((result) => {
                                if (result.isConfirmed) descargarPdf();
                            });
                        } else {
                            manejarRespuestaPdf(e.data);
                        }
                    } else {
                        Alert.Error({ text: 'Ocurrió un error al intentar guardar' });
                    }
                })
                .catch(() => Alert.Error({ text: 'Ocurrió un error al intentar guardar' }));
        }

        const getStorageListaProductos = () => {
            if (!localStorage.getItem('listaProductos')) return false;
            if (JSON.parse(localStorage.getItem('listaProductos')).length > 0) {
                Alert.Option({
                    icon: "info",
                    titles: "",
                    cancelButtonText: "Borrar",
                    confirmButtonText: "Recuperar",
                    allowOutsideClick: false,
                    cancelButtonColor: "#d33",
                    confirmButtonColor: "#198754",
                    html: "<p>Detectamos que tenes un pedido sin confirmar.</p><p>¿Deseas recuperarlo?</p>"
                }).then((e) => {
                    if (e.isConfirmed) {
                        listaProductos.value = JSON.parse(localStorage.getItem('listaProductos'));
                        if (JSON.parse(localStorage.getItem('cliente')))
                            cliente.value = JSON.parse(localStorage.getItem('cliente'));
                        descuento.value = parseInt(localStorage.getItem('descuento')) > 0 ? parseInt(localStorage.getItem('descuento')) : 0;
                        total.value = parseFloat(localStorage.getItem('total'));
                        if (cliente.value && selectSearch.value)
                            selectSearch.value.search = cliente.value.full_name;
                    } else {
                        limpiarStorage();
                    }
                });
            }
        }

        watchEffect(() => {
            if (modoEdicion.value) return;
            if (listaProductos.value.length > 0)
                localStorage.setItem('listaProductos', JSON.stringify(listaProductos.value));
            if (cliente.value && cliente.value.id)
                localStorage.setItem('cliente', JSON.stringify(cliente.value));
            if (total.value != 0)
                localStorage.setItem('total', total.value);
            if (descuento.value > 0)
                localStorage.setItem('descuento', descuento.value);
            else
                descuento.value = 0;
        });

        return {
            v$, data, cliente, selectSearch, selectProducto, producto, listas, listaSelected,
            subCampoClienteSearch, cargarProducto, quitar, listaProductos, total,
            confirmarPedido, descuento, totalConDescuento, formatMoney,
            modoEdicion, pdfBase64, descargarPdf, compartirWhatsapp, puedeCompartir, whatsappUrl, router, saldoAFavor
        };
    },
    validations() {
        return {
            listaSelected: { id: { required } },
            producto: { descripcion: { required }, precio: { required }, cantidad: { required } },
            cliente: { nombre: { required }, apellido: { required }, email: { required }, cuit: { required }, full_name: { required } }
        }
    }
};
</script>
